import { useLanderConfig } from "../commons/ConfigContext";
import { LanderCookie, System } from "../commons/Constants";
import { getCookie } from "../commons/HelperFunctions";
import { ExperimentIds } from "../commons/constants/experiment";
import { isControlCohort } from "./helper";

export function useRollerAdsUsExperiment() {
  const { landerConfig } = useLanderConfig();
  const { key, cohort } = landerConfig.experiment || {};

  const inExperiment = key === ExperimentIds.pwRollerAdsUS;
  const inTreatmentCohort =
    inExperiment && !!cohort && !isControlCohort(cohort);

  const isParkWeb = landerConfig.system === System.PARKWEB;
  const isUS = getCookie(LanderCookie.COUNTRY) === "US";

  const inRollerAdsTreatment = inTreatmentCohort && isParkWeb && isUS;

  return { inRollerAdsTreatment, inExperiment };
}
